import { useNewCode } from '@calendly/feature-check-react'

export const useActivationQ3Flag = () => useNewCode('activation_q3', false)?.enabled
